import styled from "styled-components";

export const NotFoundContainer = styled.div`
    color: white;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    text-align: center;

    p {
        font-size: 20px;
        a {
            color: #2F67DD;
        }
    }
`